import React, { memo, useContext, useEffect, useState } from 'react';
import { Text, CardContainer, AboveCard, Card, Header, LegalText, CardHeader, Link, StyledContainer, Promotion, } from './components';
import { eventParamAttributes, } from '@spotify-internal/touchdown-analytics';
import { purify } from '../../utils/helpers';
import { TextLink } from '@spotify-internal/encore-web';
import DeviceContext from '../../configuration/context/device';
export function SingleCard({ container, promotion, header, subheaders, body, legalDisclaimer, dataEventName, dataEventLabelLink, dataEventLabelLegal, supheader, link, cardBackgroundColor, aboveCardTextColor, theme, eventParams, }) {
    const dataLinkEventProps = Object.assign(Object.assign({}, (dataEventName && { 'data-event-name': dataEventName })), (dataEventLabelLink && { 'data-event-label': dataEventLabelLink }));
    const dataLegalEventProps = Object.assign(Object.assign({}, (dataEventName && { 'data-event-name': dataEventName })), (dataEventLabelLegal && { 'data-event-label': dataEventLabelLegal }));
    const device = useContext(DeviceContext);
    const [isGPBEligible, setIsGPBEligible] = useState(device.platform === 'android' && device.gpb_supported);
    useEffect(() => {
        if (device.platform === 'android' && device.gpb_supported) {
            setIsGPBEligible(true);
        }
    }, [device]);
    return (React.createElement(StyledContainer, Object.assign({}, container, eventParamAttributes(eventParams), { isGPB: isGPBEligible }),
        isGPBEligible && (React.createElement(CardContainer, null,
            (supheader || link) && (React.createElement(AboveCard, { isGPB: true },
                supheader && (React.createElement(Text, { variant: "canon", dangerouslySetInnerHTML: {
                        __html: purify(supheader),
                    } })),
                link && (React.createElement(Link, Object.assign({ href: link.url, onClick: link.onClick }, dataLinkEventProps), link.text)))),
            React.createElement(Card, Object.assign({}, theme, { isGPB: true }),
                React.createElement(CardHeader, Object.assign({}, theme),
                    header && (React.createElement(Header, { variant: "balladBold", isGPB: true, dangerouslySetInnerHTML: {
                            __html: purify(header),
                        } })),
                    body && (React.createElement(Text, { variant: "finale", isGPB: true, dangerouslySetInnerHTML: {
                            __html: purify(body),
                        } })),
                    subheaders &&
                        !!!body &&
                        subheaders.map((subheader, x) => {
                            return (React.createElement(Text, { variant: "heading4", key: x, dangerouslySetInnerHTML: {
                                    __html: purify(subheader),
                                } }));
                        })),
                legalDisclaimer && (React.createElement(LegalText, Object.assign({ text: legalDisclaimer }, dataLegalEventProps, { isGPB: true })))))),
        !isGPBEligible && (React.createElement(CardContainer, null,
            (supheader || link) && (React.createElement(AboveCard, { color: aboveCardTextColor },
                supheader && (React.createElement(Text, { variant: "body1", dangerouslySetInnerHTML: {
                        __html: purify(supheader),
                    } })),
                link && (React.createElement(TextLink, Object.assign({ href: link.url, onClick: link.onClick }, dataLinkEventProps), link.text)))),
            React.createElement(Card, { background: cardBackgroundColor, color: aboveCardTextColor },
                promotion && React.createElement(Promotion, { weight: "black" }, promotion),
                header && (React.createElement(Header, { variant: "heading3", dangerouslySetInnerHTML: {
                        __html: purify(header),
                    } })),
                subheaders &&
                    subheaders.map((subheader, x) => {
                        return (React.createElement(Text, { variant: "heading4", key: x, dangerouslySetInnerHTML: {
                                __html: purify(subheader),
                            } }));
                    }),
                legalDisclaimer && (React.createElement(LegalText, Object.assign({ text: legalDisclaimer }, dataLegalEventProps))))))));
}
export default memo(SingleCard);
//# sourceMappingURL=single-card.js.map